export const SUPER_ADMIN_TABS = ["Utilisateurs", "EHPADs", "Tournées", "Livret thérapeutique", "Maintenance"];

export const ADMIN_TABS = ["Utilisateurs", "EHPADs", "Tournées", "Livret thérapeutique"];

export const PHARMACIEN_TABS = ["EHPADs", "Tournées", "Livret thérapeutique"];

export const TAB_QUERY_KEYS = {
    "Utilisateurs": "utilisateurs",
    "EHPADs": "ehpads",
    "Tournées": "tournees",
    "Livret thérapeutique": "livret-therapeutique",
    "Maintenance": "maintenance",
};

export const ROLES = ["TITULAIRE", "ADMIN", "PHARMACIEN", "PRODUCTEUR", "LIVREUR"];

export const DEFAULT_EHPAD_COLORS = [
    "#DBEAFE", "#DCFCE7", "#FEF3C7", "#EDE9FE",
    "#FCE7F3", "#CFFAFE", "#FFEDD5", "#E0E7FF",
];

export const DEFAULT_EHPAD_COLOR = DEFAULT_EHPAD_COLORS[0];

export function nextEhpadColor(ehpads) {
    const used = new Set((ehpads || []).map(ehpad => ehpad.color?.toUpperCase()).filter(Boolean));
    return DEFAULT_EHPAD_COLORS.find(color => !used.has(color))
        ?? DEFAULT_EHPAD_COLORS[(ehpads || []).length % DEFAULT_EHPAD_COLORS.length];
}

export const AVATAR_PALETTE = [
    { bg: "#fee2e2", text: "#991b1b" },
    { bg: "#dbeafe", text: "#1e40af" },
    { bg: "#d1fae5", text: "#065f46" },
    { bg: "#fef3c7", text: "#92400e" },
    { bg: "#ede9fe", text: "#4c1d95" },
    { bg: "#e0f2fe", text: "#075985" },
    { bg: "#fce7f3", text: "#9d174d" },
    { bg: "#f3f4f6", text: "#374151" },
];

export const ROLE_STYLES = {
    TITULAIRE:   { dot: "#17B978", text: "#0C3B3C", bg: "#ecfdf5",  label: "Titulaire"   },
    PHARMACIEN:  { dot: "#22c55e", text: "#15803d", bg: "#f0fdf4",  label: "Pharmacien"  },
    ADMIN:       { dot: "#818cf8", text: "#4338ca", bg: "#eef2ff",  label: "Admin"        },
    PRODUCTEUR:  { dot: "#60a5fa", text: "#1d4ed8", bg: "#eff6ff",  label: "Préparateur" },
    LIVREUR:     { dot: "#14b8a6", text: "#0f766e", bg: "#f0fdfa",  label: "Livreur"     },
    SUPER_ADMIN: { dot: "#f59e0b", text: "#92400e", bg: "#fffbeb",  label: "Super Admin"  },
};

export function avatarColor(seed) {
    let h = 0;
    for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.codePointAt(i)) & 0xffff;
    return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
}

export function userInitials(u) {
    const f = u.firstName?.trim();
    const l = u.lastName?.trim();
    if (f && l) return (f[0] + l[0]).toUpperCase();
    if (f)     return f.slice(0, 2).toUpperCase();
    if (l)     return l.slice(0, 2).toUpperCase();
    return (u.email ?? "?")[0].toUpperCase();
}

export const PASSWORD_RULES = [
    { label: "8 caractères minimum", test: p => p.length >= 8 },
    { label: "Une majuscule", test: p => /[A-Z]/.test(p) },
    { label: "Un chiffre", test: p => /\d/.test(p) },
    { label: "Un caractère spécial (!@#$%...)", test: p => /[!@#$%^&*()_+\-=[{};':"\\|,.<>/?]/.test(p) },
];
